import { Button, Heading, Spinner, Table } from '@vwfs-bronson/bronson-react';
import { JiraProject } from '../../fes';

export function WebhookKeysTable({
  error,
  isLoading,
  onGenerateWebhookKey,
  onRevokeWebhookKey,
  revokingProjectKey,
  webhookKeys,
}: {
  error?: string;
  isLoading: boolean;
  onGenerateWebhookKey: () => void;
  onRevokeWebhookKey: (webhookKey: JiraProject) => void;
  revokingProjectKey?: string;
  webhookKeys: JiraProject[];
}) {
  return (
    <section className="app-team-panel" aria-labelledby="webhook-keys-heading">
      <div className="app-team-panel-header">
        <div>
          <div className="app-kicker">Team Detail</div>
          <Heading level={2} id="webhook-keys-heading" className="app-panel-title">
            Webhook Keys
          </Heading>
        </div>
        <div className="app-actions">
          <Button onClick={onGenerateWebhookKey} disabled={isLoading}>
            Generate webhook key
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className="app-detail-loading" role="status">
          <Spinner center>Loading webhook keys...</Spinner>
        </div>
      ) : error ? (
        <div className="app-result app-team-error" role="alert">
          {error}
        </div>
      ) : webhookKeys.length === 0 ? (
        <p className="app-empty">No webhook keys found.</p>
      ) : (
        <div className="app-table-wrap">
          <Table className="app-table" colored>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Project Key</Table.Th>
                <Table.Th>Agent ID</Table.Th>
                <Table.Th>Description</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Created At</Table.Th>
                <Table.Th>Created By</Table.Th>
                <Table.Th>Revoked At</Table.Th>
                <Table.Th>Actions</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {webhookKeys.map(webhookKey => {
                const isRevoked = webhookKey.status === 'revoked';
                const isRevoking = revokingProjectKey === webhookKey.projectKey;

                return (
                  <Table.Tr key={webhookKey.projectKey}>
                    <Table.Td>{webhookKey.projectKey}</Table.Td>
                    <Table.Td>{webhookKey.agentId}</Table.Td>
                    <Table.Td>{webhookKey.description || '-'}</Table.Td>
                    <Table.Td>{webhookKey.status}</Table.Td>
                    <Table.Td>{webhookKey.createdAt}</Table.Td>
                    <Table.Td>{webhookKey.createdBy || '-'}</Table.Td>
                    <Table.Td>{webhookKey.revokedAt || '-'}</Table.Td>
                    <Table.Td>
                      <Button
                        ariaLabel={`Revoke webhook key ${webhookKey.projectKey}`}
                        className="app-table-icon-button"
                        disabled={isLoading || isRevoked || isRevoking}
                        hiddenLabel
                        icon="semantic-delete"
                        incognito
                        onClick={() => onRevokeWebhookKey(webhookKey)}
                        small
                        title={isRevoked ? 'Webhook key already revoked' : `Revoke ${webhookKey.projectKey}`}
                      >
                        Revoke
                      </Button>
                    </Table.Td>
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </div>
      )}
    </section>
  );
}
